<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="19">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">一、当事人基本信息</span>
                <p>{{bz}}</p>
                <el-button type="warning" size="small" @click="getBack">返回</el-button>
                <el-button type="primary" size="small" @click="getBack" style="margin:5px 0 0 10px;">基本信息同步按钮</el-button>
            </div>
            <div class="box-cont">
                <el-form :model="form1" ref="form1" label-width="100px">
                    <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="当事人:" prop="dwmc">
                            <el-input disabled
                            v-model="form1.dwmc"
                            placeholder="请输入当事人"
                            clearable
                            size="small"
                            
                            />
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                    <el-form-item label="地址:" prop="dwdz">
                        <el-input :disabled="dwForm.dwdz?true:false"
                        v-model="form1.dwdz"
                        placeholder="请输入地址"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                     <el-col :span="12">
                    <el-form-item label="卫生许可证号:" prop="xkzh">
                        <el-input  :disabled="dwForm.xkzh?true:false"
                        v-model="form1.xkzh"
                        placeholder="请输入卫生许可证号"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                     <el-col :span="12">
                    <el-form-item label="统一社会信用代码:" prop="zzdm" label-width="140px">
                        <el-input  :disabled="dwForm.zzdm?true:false"
                        v-model="form1.zzdm"
                        placeholder="请输入统一社会信用代码"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                     <el-col :span="12">
                        <div style="width:270px;float:left;">
                    <el-form-item label="经营者:" prop="fzr" >
                        <el-input  :disabled="dwForm.fzr?true:false"
                        v-model="form1.fzr"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                        </div>
                        <div style="width:calc(100% - 270px);float:left;">
                    <el-form-item label="性别:" prop="frxb" label-width="60px">
                        <el-select v-model="form1.frxb"  :disabled="dwForm.frxb?true:false" placeholder="请选择" size="small" style="max-width:140px;">
                            <el-option 
                                v-for="dict in xbOptions"
                                :key="dict.id"
                                :label="dict.label"
                                :value="dict.label"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </div>
                </el-col>
                     <el-col :span="12">
                        <div style="width:270px;float:left;">
                            <el-form-item label="民族:" prop="nation">
                        <el-select v-model="form1.nation"  :disabled="dwForm.nation?true:false" placeholder="请选择民族" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in mzOptions"
                                :key="dict.id"
                                :label="dict.nation"
                                :value="dict.xh"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </div>
                        <div style="width:calc(100% - 270px);float:left;">
                    <el-form-item label="职务:" prop="frzw" label-width="60px">
                        <el-select v-model="form1.frzw"  :disabled="dwForm.frzw?true:false" placeholder="请选择职务" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in zwOptions"
                                :key="dict.px"
                                :label="dict.zw"
                                :value="dict.zw"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </div>
                </el-col>
                     <el-col :span="9">
                    <el-form-item label="身份证号:" prop="sfzh">
                        <el-input  :disabled="dwForm.sfzh?true:false"
                        v-model="form1.sfzh"
                        placeholder="请输入身份证号"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                <el-form-item label="联系电话:" prop="sj1">
                        <el-input  :disabled="dwForm.sj1?true:false"
                        v-model="form1.sj1"
                        placeholder="请输入联系电话"
                        clearable
                        size="small"
                        />
                    </el-form-item>  
                </el-col> 
                     <!-- <el-col :span="8" v-if="isNew == 2">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="handleAdd">变更当事人基本信息</el-button>
                    </el-form-item>
                     </el-col> -->
                    </el-row>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">二、案件基本信息</span>
            </div>
            <div class="box-cont">
                <el-form :model="form2" ref="queryForm2" label-width="100px">
                    <el-row>
                        <el-col :span="12">
                    <el-form-item label="案件来源:" prop="laiyuan">
                        <el-select v-model="form2.laiyuan" placeholder="请选择案件来源" size="small" @change="changeXcbl">
                            <el-option
                                v-for="dict in lyOptions"
                                :key="dict.id"
                                :label="dict.ajly"
                                :value="dict.ajly"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <!-- <el-col :span="12">
                    <el-form-item label="立案审批文号:" prop="lianWenhao">
                        <el-input
                        v-model="form2.lianWenhao"
                        placeholder="请输入立案审批文号"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :span="6">
                    <el-form-item label="采样日期:" prop="jiancha_rq">
                        <el-date-picker size="small"
                            v-model="form2.jiancha_rq"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="检测公司:" prop="lianWenhao">
                        <el-input
                        v-model="form2.lianWenhao"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="报告编号:" prop="lianWenhao">
                        <el-input
                        v-model="form2.lianWenhao"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="接收日期:" prop="jiancha_rq">
                        <el-date-picker size="small"
                            v-model="form2.jiancha_rq"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="告知日期:" prop="jiancha_rq">
                        <el-date-picker size="small"
                            v-model="form2.jiancha_rq"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col> -->
                     <!-- <el-col :span="6">
                    <el-form-item label="国家双随机:" prop="gjssj">
                        <el-radio-group v-model="form2.gjssj">
                            <el-radio :label="'yes'">是</el-radio>
                            <el-radio :label="'no'">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="省级双随机:" prop="sjssj">
                        <el-radio-group v-model="form2.sjssj">
                            <el-radio :label="'yes'">是</el-radio>
                            <el-radio :label="'no'">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="一般检查:" prop="isybjc">
                        <el-radio-group v-model="form2.isybjc">
                            <el-radio :label="'yes'">是</el-radio>
                            <el-radio :label="'no'">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="投诉举报:" prop="istsjb">
                        <el-radio-group v-model="form2.istsjb">
                            <el-radio :label="'yes'">是</el-radio>
                            <el-radio :label="'no'">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col> -->
                     <el-col :span="6">
                    <el-form-item label="检查日期:" prop="jiancha_rq">
                        <el-date-picker size="small" style="width:140px;"
                            v-model="form2.jiancha_rq"
                            type="date" 
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="受理日期:" prop="shouli_rq">
                        <el-date-picker size="small" style="width:140px;"
                            v-model="form2.shouli_rq"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="立案日期:" prop="lian_rq">
                        <el-date-picker size="small" style="width:140px;"
                            v-model="form2.lian_rq"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                     <el-col :span="18">
                    <el-form-item label="合议时间:">
                        <el-date-picker size="small" style="float:left; margin-right:10px;width:140px;"
                            v-model="form2.heyisj"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <el-time-picker style="float:left;"
                            is-range size="small" editable
                            v-model="form2.heyisj2"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围" @blur="getHysj()">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="违反法律:" prop="law">
                        <el-input disabled
                        v-model="form2.law"
                        clearable
                        size="small" style="width:calc(100% - 200px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getFalv('违反法律',1)">违反法律</el-button>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="处罚依据:" prop="punish_basis">
                        <el-input disabled
                        v-model="form2.punish_basis"
                        clearable
                        size="small" style="width:calc(100% - 200px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getFalv('处罚依据',2)">法律引用</el-button>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="拟予处罚:">
                        <el-checkbox v-model="form2.jinggao" >警告</el-checkbox>
                        <el-checkbox name="type" v-model="form2.fakuan">
                            <span>罚款</span>
                            <el-input v-model="form2.fakuanJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                            :disabled="!form2.fakuan" @input="form2.fakuanJine=form2.fakuanJine.replace(/[^\d.]/g,'')"></el-input>
                            <span>元</span>
                        </el-checkbox>
                        <el-checkbox name="type" v-model="form2.moshou">
                            <span>没收非法所得</span>
                            <el-input v-model="form2.moshouJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                            :disabled="!form2.moshou" @input="form2.moshouJine=form2.moshouJine.replace(/[^\d.]/g,'')"></el-input>
                            <span>元</span>
                        </el-checkbox>
                        <el-checkbox v-model="form2.isdx" @change="getDxnrtk">吊销{{text1}}</el-checkbox>
                        <el-checkbox v-model="form2.iszl" @change="getZlnrtk">{{text2}}</el-checkbox>
                        <el-checkbox name="type" v-model="form2.moshou2">
                            <span>没收</span>
                            <el-input v-model="form2.txtWupin" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                            :disabled="!form2.moshou2" @input="form2.txtWupin=form2.txtWupin.replace(/[^\d.]/g, '')"></el-input>
                        </el-checkbox>
                        <el-checkbox v-model="form2.buyuChufa" >不予处罚</el-checkbox>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="经办科室:" prop="jingbanks">
                        <el-select v-model="form2.jingbanks" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                                v-for="(dict,index) in ksOptions"
                                :key="index"
                                :label="dict.gzbm"
                                :value="dict.gzbm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="主办人员:" prop="host_man">
                        <el-select v-model="form2.host_man" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                :label="dict.xm"
                                :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="协办人员:" prop="xiebanren">
                        <el-select v-model="form2.xiebanren" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="实际主办人员:" prop="factHost">
                        <el-select v-model="form2.factHost" placeholder="请选择" size="small" style="width:120px;" @change="getHostdh">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="主办人电话:" prop="hostdh">
                        <el-input disabled
                        v-model="form2.hostdh"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:120px;"
                        />
                    </el-form-item>
                </el-col>
                     <el-col :span="18">
                    <el-form-item label="合议人员:" prop="join_man">
                        <el-select v-model="form2.join_man" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="主案由:" prop="reason2">
                        <el-input disabled
                        v-model="form2.reason1"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:200px;margin-right:10px;"
                        />
                        <el-input disabled
                        v-model="form2.reason2"
                        placeholder="请输入"
                        clearable
                        size="small"  style="width:calc(100% - 410px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getAnyou('主案由',1)">选择模板</el-button>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="从案由:" prop="reason22">
                        <el-input disabled
                        v-model="form2.reason1"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:200px;margin-right:10px;"
                        />
                        <el-input disabled
                        v-model="form2.reason22"
                        placeholder="请输入"
                        clearable
                        size="small"  style="width:calc(100% - 410px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getAnyou('从案由',2)">选择模板</el-button>
                        <el-button type="primary" size="small" @click="addAnyou()">增加从案由</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-show="isAy > 1">
                    <el-form-item v-for="(item,index) in form2.domains" :key="index" :label="'从案由'+item.key+':'" >
                        <el-input
                        v-model="form2.reason1"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:200px;margin-right:10px;"
                        />
                        <el-input disabled
                        v-model="item.value"
                        placeholder="请输入"
                        clearable
                        size="small"  style="width:calc(100% - 410px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getAnyou('从案由',2,index)">选择模板</el-button>
                        <el-button type="primary" size="small" @click="delectAnyou(index)">删除</el-button>
                    </el-form-item>
                </el-col>
                     <el-col :span="24">
                    <el-form-item label="合并案由:" prop="hbay">
                        <el-input disabled
                        v-model="form2.reason1"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:200px;margin-right:10px;"
                        />
                        <el-input disabled
                        v-model="form2.hreason22"
                        placeholder="请输入"
                        clearable
                        size="small" style="width:calc(100% - 410px);margin-right:10px;"
                        />
                        <el-button type="primary" size="small" @click="getAnyou(4)">合并案由</el-button>
                    </el-form-item>
                </el-col>
                     <el-col :span="12">
                    <el-form-item label="告知书文号:" prop="gzswh">
                        <span>{{form2.wenhaopre}}</span>
                        <el-select  size="small" v-model="aj_list.gzsNo2" placeholder="请选择执法类别" clearable  style="margin:0 10px;width: 60px;"  :disabled="aj_list.gzsNo2?true:false">
                            <el-option value="水">水</el-option>
                            <el-option value="学">学</el-option>
                            <el-option value="医">医</el-option>
                            <el-option value="职">职</el-option>
                            <el-option value="传">传</el-option>
                            <el-option value="放">放</el-option>
                            <el-option value="公">公</el-option>
                            <el-option value="血液">血液</el-option>
                            <el-option value="消">消</el-option>
                            <el-option value="计生">计生</el-option>
                            <el-option value="爱">爱</el-option>
                        </el-select>
                        <span>罚告</span>
                        <el-input size="small" v-model="aj_list.gzsNo3" :style="{width: '20%'}" style="margin:0 10px;" :disabled="isNew==2"></el-input>
                        <el-input size="small" v-model="aj_list.gzsNo4" :style="{width: '20%'}" :disabled="isNew==2"></el-input>
                        <span style="margin-left:10px;">号</span>
                    </el-form-item>
                </el-col>
                     <el-col :span="12">
                    <el-form-item label="决定书文号:" prop="jdswh">
                        <span>{{form2.wenhaopre}}</span>
                        <el-select  size="small" v-model="aj_list.jdsNo2" placeholder="请选择执法类别" clearable style="margin:0 10px; width:60px;"  :disabled="aj_list.jdsNo2?true:false">
                            <el-option value="水">水</el-option>
                            <el-option value="学">学</el-option>
                            <el-option value="医">医</el-option>
                            <el-option value="职">职</el-option>
                            <el-option value="传">传</el-option>
                            <el-option value="放">放</el-option>
                            <el-option value="公">公</el-option>
                            <el-option value="血液">血液</el-option>
                            <el-option value="消">消</el-option>
                            <el-option value="计生">计生</el-option>
                            <el-option value="爱">爱</el-option>
                        </el-select>
                        <span>罚</span>
                        <el-input size="small" v-model="aj_list.jdsNo3" :style="{width: '20%'}" style="margin:0 10px;" :disabled="isNew==2"></el-input>
                        <el-input size="small" v-model="aj_list.jdsNo4" :style="{width: '20%'}" :disabled="isNew==2"></el-input>
                        <span style="margin-left:10px;">号</span>
                    </el-form-item>
                     </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card" style="text-align:center;">
            <el-button type="primary" @click="save"> 暂 存 </el-button>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">三、案情摘要（<b style="color:red;">注：以下数据从省系统同步，无需录入！</b>）</span>
            </div>
            <div class="box-cont">
                <el-form :model="form2" ref="queryForm3" label-width="140px">
                    <el-form-item label="现场笔录记录内容:" prop="content12">
                        <p>{{form2.content11}}</p>
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content12" size="small"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getBacl()">并案处理</el-button>
                            <el-button type="primary" size="small" @click="getBlzdy()">自定义</el-button>
                            <el-button type="primary" size="small" @click="getFuzhi(form2.content12)">复制内容</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="调查询问过程描述:" prop="content2">
                        <p style="background:#ffff00;">{{aj_list.xwms}}</p>
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content2"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getXwtk()">选择模板</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="违法事实:" prop="content3">
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content3"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getWfss()">选择模板</el-button>
                            <el-button type="primary" size="small" @click="getFuzhi(form2.content3)">复制内容</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="本案取得的证据:" prop="content4">
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content4"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getBazj()">选择模板</el-button>
                            <el-button type="primary" size="small" @click="getFuzhi(form2.content4)">复制内容</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="案件调查终结报告上的处理建议:" prop="content5">
                        <p style="background:#ffff00;">当事人的行为违反了{{form2.law}}的规定，依据{{form2.punish_basis}}，</p>
                        <!-- <p style="background:#ffff00;">{{form2.content3}}</p> -->
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content5"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getCljy()">通用模板</el-button>
                            <el-button type="primary" size="small" >固定模板</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="合议记录（告知书、决定书）上的说理内容:" prop="content6">
                        <p style="background:#ffff00;">本机关认为：</p>
                        <el-input type="textarea" :rows="5"
                        v-model="form2.content6"
                        />
                        <div class="btns">
                            <el-button type="primary" size="small" @click="getSlnr()">选择模板</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item style="text-align:center;">
                        <el-button type="primary" size="small" @click="provinceData">省数据同步</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">智能评测</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">预览评查表</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">保存上报</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
            </el-col>
            <el-col :span="5">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="text">文书</span>
                    </div>
                    <div class="box-cont">
                        <div class="demo-input-suffix">
                            <el-input class="search"
                                placeholder="请输入文书名称查询"
                                v-model="wsName">
                                <i slot="suffix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                        <ul>
                            <li v-for="(item,index) in wsList" :key="index" @click="showEdit(item)">
                                <p>
                                    <span>{{item.wsName}}</span>
                                    <i v-if="item.isWc" class="el-icon-circle-check"></i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="title" :visible.sync="open" top="5vh" :width="width" append-to-body :close-on-click-modal="false">
            <xwbl v-if="this.code == 'xwbl'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <xcbl v-else-if="this.code == 'xcbl'" :code="this.code" :pcId="this.ajId" :hysj="this.form2.heyisj" @handleBack="handleBack"  />
            <jdyjs v-else-if="this.code == 'wsjdyjs'" :code="this.code" :pcId="this.ajId" :text="this.form2.content3" :anyou="this.form2.reason2" :cfyj="this.form2.punish_basis" @handleBack="handleBack"  />
            <cyjl v-else-if="this.code == 'cyjl'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <jyjggzs v-else-if="this.code == 'jyjggzs'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <cfajfm v-else-if="this.code == 'cfajfm'" :code="this.code" :pcId="this.ajId" :rq="this.form2.jiancha_rq" @handleBack="handleBack"  />
            <cfajml v-else-if="this.code == 'cfajml'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <sdhz v-else-if="this.code == 'sdhz'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <jnbkb v-else-if="this.code == 'jnbkb'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <jdyzfz v-else-if="this.code == 'jdyzfz'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <zjxxdjbcjds v-else-if="this.code == 'zjxxdjbcjds'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <zjxxdjbccljds v-else-if="this.code == 'zjxxdjbccljds'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <fp v-else-if="this.code == 'fp'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <span v-else>9999</span>
        </el-dialog>

        <el-dialog title="现场笔录信息" :visible.sync="open2" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <el-form :model="queryParams" ref="queryForm" :inline="true">
                <el-form-item label="单位名称(个人名称):" prop="dwmc">
                    <el-input
                    v-model="queryParams.dwmc"
                    placeholder="请输入单位名称(个人名称)"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="isXcbl">无需现场笔录</el-checkbox>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="xcblList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位名称" prop="dwmc" />
                        <el-table-column label="执法类别" align="center" prop="ssjType" width="110"  />
                        <el-table-column label="处罚" prop="ischufa" width="50"  />
                        <el-table-column label="检测" prop="isjiance" width="50" />
                        <el-table-column label="专业类别" prop="zflb" width="90" />
                        <el-table-column label="检查人员1" align="center" prop="jdy1" width="90" />
                        <el-table-column label="检查人员2" align="center" prop="jdy2"  width="90" />
                        <el-table-column label="检查日期" align="center" prop="bl_date" width="110"  />
                        <el-table-column label="记录有无" align="center" width="80" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.xcbl_bh">有</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="选择" align="center" class-name="small-padding fixed-width" width="50" >
                            <template slot-scope="scope">
                               <el-checkbox @change="handleSelect(scope.row)"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div>
        </el-dialog>

        <el-dialog :title="title3" :visible.sync="open3" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <falv :leixing="this.leixing" :text="this.title3" @handleBack="handleBackFalv" @falvTk="closeFalv" />
        </el-dialog>

        <el-dialog :title="title4" :visible.sync="open4" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <anyou :leixing="this.leixing2" :text="this.title4" @handleBack="handleBackAnyou" @closeTk="closeAnyou"  />
        </el-dialog>

        <el-dialog title="请输入并案理由" :visible.sync="open5" width="500px" append-to-body :close-on-click-modal="false">
            <el-input type="textarea" :rows="8" placeholder="请输入并案理由" v-model="baly" />
            <div style="margin-top:20px; text-align:right;">
                <el-button type="primary" size="small" @click="balyTj">提交</el-button>
                <el-button type="info" size="small" @click="open5 = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="open6" width="500px" append-to-body :close-on-click-modal="false">
            <div>
                <br/>
                <el-form label-width="100px">
                    <el-form-item label="吊销" prop="dxnr" >
                        <el-input v-model="dxnr" placeholder="" clearable  size="small" style="width:80%;" />
                    </el-form-item>
                </el-form>
                <p style="text-align:center;">
                        <el-button type="primary" size="small" @click="getDxnr">确定</el-button>
                </p>
                <br/>
                <p style="color:red;"><b>备注：请注明吊销的详细内容，譬如：内科的诊疗科目，而不能是“内科”二字。</b></p>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="open7" width="500px" append-to-body :close-on-click-modal="false">
            <div>
                <el-radio-group v-model="zllx" @change="getZl" style="margin:20px 0;">
                    <el-radio label="责令停产">责令停产</el-radio>
                    <el-radio label="责令停业">责令停业</el-radio>
                    <el-radio label="暂停执业">暂停执业</el-radio>
                </el-radio-group>
                <el-form label-width="100px" :inline="true">
                    <el-form-item prop="zlnr" >
                        <el-input v-model="zlnr" placeholder="" clearable  size="small" style="width:80%;" :disabled="zllx == '暂停执业' ? false : true" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="getZlnr">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog title="省系统信息同步" :visible.sync="open8" width="1000px" append-to-body :close-on-click-modal="false">
            <div>
                <p>温馨提醒！</p>
                <p>1.未查到此单位在"浙江省数智卫监精密智控系统"里受理与立案信息，请进入省系统受理与立案。</p>
                <p>2.如已核实此单位在省系统中已经受理与立案，请关闭此窗口，重新进行省系统数据同步。</p>
                <p>3.如无需同步省系统的数据，请点击继续保存上报</p>
                <el-button type="primary" >进入数智卫监精密智控系统</el-button>
                <el-button type="danger" @click="open8 = false">继续保存上报</el-button>
            </div>
        </el-dialog>

        <el-dialog title="笔录记录内容" :visible.sync="open9" width="500px" append-to-body :close-on-click-modal="false">
            <el-input type="textarea" :rows="8" placeholder="请输入笔录记录内容" v-model="blnr" />
            <div style="margin-top:20px; text-align:right;">
                <el-button type="primary" size="small" @click="zdyblTj">提交</el-button>
                <el-button type="info" size="small" @click="open9 = false">取消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="调查询问过程描述" :visible.sync="open10" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <xunwen :text="this.form2.content2" @handleBackXunwen="handleBackXunwen" @xunwenTk="closeXunwen"  />
        </el-dialog>

        <el-dialog title="违法事实" :visible.sync="open11" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <shishi :text="this.form2.content3" @handleBackShishi="handleBackShishi" @shishiTk="closeShishi"  />
        </el-dialog>

        <el-dialog title="本案取得的证据" :visible.sync="open12" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <zhengju :text="this.form2.content4" @handleBackZhengju="handleBackZhengju" @zhengjuTk="closeZhengju"  />
        </el-dialog>

        <el-dialog title="终结报告上的处理建议" :visible.sync="open13" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <jianyi :text="this.form2.content5" @handleBackJianyi="handleBackJianyi" @jianyiTk="closeJianyi"  />
        </el-dialog>

        <el-dialog title="合议记录上的说理内容" :visible.sync="open14" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <shuoli :text="this.form2.content6" :law="this.form2.law" :cfyj="this.form2.punish_basis" :cljy="this.form2.content5" @handleBackShuoli="handleBackShuoli" @shuoliTk="closeShuoli"  />
        </el-dialog>
    </div>
</template>

<script>
import xwbl from '../wslb/xwbl.vue'
import xcbl from '../wslb/xcbl.vue'
import jdyjs from '../wslb/jdyjs.vue'
import cyjl from '../wslb/cyjl.vue'
import jyjggzs from '../wslb/jyjggzs.vue'
import zjxxdjbcjds from '../wslb/zjxxdjbcjds.vue'
import zjxxdjbccljds from '../wslb/zjxxdjbccljds.vue'
import cfajfm from '../wslb/cfajfm.vue'
import cfajml from '../wslb/cfajml.vue'
import sdhz from '../wslb/sdhz.vue'
import jnbkb from '../wslb/jnbkb.vue'
import jdyzfz from '../wslb/jdyzfz.vue'
import fp from '../wslb/fp.vue'

import falv from './falv.vue'
import anyou from './anyou.vue'
import xunwen from './xunwen.vue'
import shishi from './shishi.vue'
import zhengju from './zhengju.vue'
import jianyi from './jianyi.vue'
import shuoli from './shuoli.vue'

import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['ajId','dwId','dwFlag','ajFlag','isNew','row'],
    data() {
        return {
            loading:false,
            bz:'',
            dm:'',
            xm:'',
            cmid:'',
            dwForm:{},
            form1:{},
            form2:{
                wenhaopre:'',
                spLsh:null,
                bl_lsh:null, 
                dwmc_id:null,
                jiancha_rq:null, 
                jc_rq:null,
                laiyuan:null,
                lian_rq:null,
                shouli_rq:null, 
                aj_shouli_rq:null,
                heyisj:null, 
                heyisj_begin:null,  
                heyisj_end:null,
                jinggao:false, 
                fakuan:false, 
                fakuanJine:'', 
                moshou:false, 
                moshouJine:'', 
                moshou2:false, 
                txtWupin:'', 
                law:null,
                punish_basis:null,
                jingbanKs:null,
                host_man:null,
                hostdh:null,
                factHost:null,
                cooperate_man:null,
                join_man:null,
                reason1:null,
                reason2:null,
                reason22:null,
                lianWenhao:null,
                gzsNo2:null,
                gzsNo3:null,
                gzsNo4:null,
                jdsNo2:null,
                jdsNo3:null,
                jdsNo4:null,
                content11:null,
                dashuju:null,
                content12:null,
                content2:null,
                content3:null,
                content4:null,
                content5:null,
                content6:null,
                dwdz:null,
                xkzh:null,
                fzr:null,
                xb:null,
                nation:null,
                zw: null,
                tyshxydm:null,
                sfzh: null,
                sj1: null,
                dwdz2:null,
                xkzh2:null,
                fzr2:null,
                xb2:null,
                nation2:null,
                zw2: null,
                tyshxydm2: null,
                sfzh2: null,
                sj12:null,
                ts_shijian:null,
                ts_nr:null,
                jc_company:null,
                jc_jcbh:null,
                jc_jieshouDate:null,
                jc_gaozhiDate:null,
                content112:null,
                content113:null,
                sjssj:null,
                gjssj:null,
                isybjc:null,
                istsjb:null,
                dxxkz:null,
                zltcty:null,
                xwbl_splsh:null,
                zyclid:null,
                buyuChufa:null,
                isnoxcbl:null,
                strpunishCaseCode:null,
                domains:[],
            },
            form3:{},
            xbOptions:[
                {id:1,label:'男'},
                {id:2,label:'女'}
            ],
            mzOptions:[],
            zwOptions:[],
            lyOptions:[],
            ksOptions:[],
            userOptions:[],
            dhOptions:[],
            whpreOptions:[],
            aj_list:[],
            open:false,
            wsList:[
                {wsCode:'xwbl',wsName:'询问笔录',isWc:true},
                {wsCode:'xcbl',wsName:'现场笔录',isWc:false},
                {wsCode:'wsjdyjs',wsName:'卫生监督意见书',isWc:false},
                {wsCode:'jyjggzs',wsName:'检验结果告知书',isWc:false},
                
                {wsCode:'zjxxdjbcjds',wsName:'证据先行登记保存决定书',isWc:false},
                {wsCode:'zjxxdjbccljds',wsName:'证据先行登记保存处理决定书',isWc:false},
                // {wsCode:'cyjl',wsName:'采样记录',isWc:false},
                // {wsCode:'fcpcyjl',wsName:'非产品采样记录',isWc:false},
                {wsCode:'cfajfm',wsName:'处罚案卷封面',isWc:false},
                {wsCode:'cfajml',wsName:'处罚案卷目录',isWc:false},
                {wsCode:'sdhz',wsName:'送达回执',isWc:false},
                {wsCode:'jnbkb',wsName:'卷内备考表',isWc:false},
                // {wsCode:'jdyzfz',wsName:'监督员执法证',isWc:false},
                // {wsCode:'fp',wsName:'发票',isWc:false},
            ],
            cfCheck:[],
            wsName:'',
            title:'',
            open:false,
            code:'',
            width:'1000px',
            open2:false,
            queryParams:{
                dwmc:'',
                page:1,
                limit:10,
            },
            isXcbl:false,
            total:0,
            xcblList:[],
            pageshow:true,
            checked:false,
            open3:false,
            title3:'',
            leixing:'',
            open4:false,
            title4:'',
            leixing2:'',
            open5:false,
            baly:'',
            isAy:1,
            open6:false,
            open7:false,
            open8:false,
            dxnr:'',
            text1:'',
            text2:'',
            zllx:'',
            zlnr:'',
            open9:false,
            blnr:'',
            open10:false,
            textXw:'',
            open11:false,
            open12:false,
            open13:false,
            open14:false,
            baseUrl:''
        }
    },
    components: {
        xwbl,
        xcbl,
        jdyjs,
        jyjggzs,
        cyjl,
        zjxxdjbcjds,
        zjxxdjbccljds,
        cfajfm,
        cfajml,
        sdhz,
        jnbkb,
        jdyzfz,
        fp,
        falv,
        anyou,
        xunwen,
        shishi,
        zhengju,
        jianyi,
        shuoli
    },
    computed: {
    },
    created() {
        console.log(this.ajId,this.dwId,this.isNew)
        if(this.isNew == 1){
            this.$message({
                showClose: true,
                message: '请先选择案件来源，然后进行基础信息比对！',
                type: 'warning'
            });
        }
    },
    async mounted() {
        console.log(this.$route)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.xm = user.xm 
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        this.form2.sjzbr = user.xm
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions = []
                let arr = res.data.data
                arr.forEach(item => {
                    let i = Number(item.id) < 10 ? '0'+item.id : item.id
                    this.mzOptions.push({id: item.id,nation: item.nation,px: item.px,xh:i})
                })
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })  
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getjbks`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.ksOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(response => {
            this.userOptions = response.data.data
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   
        if(this.isNew == 1){
            this.bz = '创建人：'+user.xm+'，联系电话：'+user.sj1
        }else{
            let data3 = await this.$axios.get(`${this.Global._baseUrl2}?act=getdsrjbxx&id=${this.ajId}`)
            console.log(data3.data)
            if(data3.data){
                this.bz = data3.data[0].data
            }
        }
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getajly`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                pcId:this.pcId,
            }
        })
        .then(response => {
            console.log(response.data);
            this.lyOptions = response.data.data || []
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        
        this.getList()
        if(this.isNew == 2){
            this.form2.law = this.row.law
            this.form2.punish_basis = this.row.punish_basis
            this.getList2()

        }
        
    },
    methods: {
        getList(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getajxqym`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmcId: this.dwId,
                    ajflag: 1,
                    dwFlag:''
                }
            })
            .then(response => {
                console.log(response.data);
                this.form1 = response.data.data[0]
                this.dwForm = Object.assign({}, response.data.data[0]);
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        async getList2(){
            let dataF = await this.$axios.get(`${this.Global._baseUrl2}?act=getFujiancailiaoCount&pcId=${this.ajId}`)
            console.log(dataF.data,819)
            if(dataF.data){

            }
            
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.ajId}`)
            console.log(data)
            if(data.data){
                let obj = data.data[0]
                for(var i in this.form2){
                    for(var p in obj){
                        if(i == p){
                            this.form2[i] = obj[p]
                        }
                    }
                }
                if(this.form2.host_man){

                }else{
                    this.form2.host_man = this.row.host_man
                    this.userOptions.forEach(item => {
                        if(item.xm == this.row.host_man){
                            this.form2.hostdh = item.ksdh
                        }
                    })
                }
                
                this.form2.reason1 = this.form2.reason1 ? this.form2.reason1 : this.form1.dwmc
                if(data.data[0].heyisj_begin){
                    let dt = data.data[0].heyisj_begin.split(' ')
                    console.log(dt)
                    this.form2.heyisj = this.getDate(dt[0],'yyyy-MM-dd')
                    let dt2 = data.data[0].heyisj_end.split(' ')
                    console.log(dt2)
                    this.form2.heyisj2 = [data.data[0].heyisj_begin,data.data[0].heyisj_end]
                    console.log(this.form2.heyisj,this.form2.heyisj2)
                }
                
                this.form2.isdx = data.data[0].dxxkz == '' ? false : true
                this.text1 = this.form2.dxxkz ? this.form2.dxxkz : '许可证'
                this.form2.iszl = data.data[0].zltcty == '' ? false : true
                this.text2 = data.data[0].zltcty == '' ? '责令停产停业' : data.data[0].zltcty
                this.form2.jinggao = data.data[0].jinggao != '警告'?false:true
                this.form2.fakuan = Number(data.data[0].fakuan) > 0 ?true:false
                this.form2.fakuanJine = Number(data.data[0].fakuan) > 0 ? Number(data.data[0].fakuan) : ''
                this.form2.moshou = Number(data.data[0].moshou) > 0 ?true:false
                this.form2.moshouJine = Number(data.data[0].moshou) > 0 ? Number(data.data[0].moshou) : ''
                this.form2.moshou2 = Number(data.data[0].moshouwp) > 0 ?true:false
                this.form2.txtWupin = Number(data.data[0].moshouwp) > 0 ? Number(data.data[0].moshouwp) : ''
                console.log(this.form2)
            }
            let dataS = await this.$axios.get(`${this.Global._baseUrl2}?act=getSplsh&id=${this.ajId}`)
            console.log(dataS.data,835)
            if(dataS.data){
                this.form2.spLsh = dataS.data[0].splsh
            }
            let dataX = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblJlnrShenpi&lshId=${this.ajId}`)
            console.log(dataX.data,840)
            if(dataX.data){
                
            }
        },
        //获取主办人电话
        getHostdh(){
            let obj =  this.userOptions.filter(item => {
                return item.xm === this.form2.factHost
            })
            console.log(obj)
            this.form2.hostdh = obj[0].ksdh
        },
        //吊销
        getDxnrtk(){
            console.log(this.form2.isdx)
            if(!this.form2.isdx){
                this.text1 = '许可证'
                this.form2.dxxkz = ''
                console.log(this.text1)
                this.$forceUpdate()
            }else{
                this.open6 = true
                this.dxnr = ''
            }
            
        },
        getDxnr(){
            console.log(this.dxnr)
            if(this.dxnr){
                this.text1 =  this.dxnr
                this.form2.dxxkz = this.dxnr
                this.open6 = false
            }else{
                this.$message.error('吊销内容不能为空')
            }
        },
        //责令
        getZlnrtk(){
            console.log(this.form2.iszl)
            if(!this.form2.iszl){
                this.text2 = '责令停产停业'
                this.form2.zltcty = ''
                this.$forceUpdate()
            }else{
                this.open7 = true
                this.zllx = ''
                this.zlnr = ''
            }
            
        },
        getZl(){
            console.log(this.zllx)
        },
        getZlnr(){
            console.log(this.zllx)
            if(this.zllx){
                this.text2 =  this.zllx+this.zlnr
                this.form2.zltcty = this.zllx+this.zlnr
                this.open7 = false
            }else{
                this.$message.error('吊销内容不能为空')
            }
        },
        async changeXcbl(){
            this.open2 = true
            let dwmc = this.queryParams.dwmc ? this.queryParams.dwmc : this.form1.dwmc
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(dwmc)}&mid=${this.form1.mid}`)
            if(data.data){
                this.xcblList = data.data
                this.total = data.data.length
            }
        },
        renew(e){
            this.$forceUpdate()
        },
        getNm(e){
            console.log(e)
            // e = e.replace(/[^\d.]/g, '')
            if (isNaN(e) || e <= 0) {
                e = '';
            } else {
                e = Number(e);
            }
          this.$forceUpdate()
        },
        handleSelect(row){
            console.log(row)
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        handleQuery(){
            this.changeXcbl()
        },
        getCf(){
            console.log(this.cfCheck)
        },
        getBack(){
            let that = this
            this.$confirm("您是否确定当前页面数据已保存吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                that.$emit('handleBack',1)
            })
        },
        async showEdit(item){
            if(item.wsCode == 'cfajml' || item.wsCode == 'zjxxdjbcjds'){
                this.width = '1200px'
            }else{
                this.width = '1000px'
            }
            if(item.wsCode == 'xwbl'){
                console.log(1239)
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getIsGsp&pcId=${this.ajId}`)
                if(data.data == 0){
                    this.$alert('此单位没有悬挂公示牌，请悉知！', '', {
                        confirmButtonText: '确定',
                        callback: action => {
                            // this.$message({
                            // type: 'info',
                            // message: ``
                            // });
                        }
                    }); 
                }
            }
            if(item.wsCode == 'wsjdyjs'){
                console.log(1269,this.form2.reason2,this.form2.content3)
                if(!this.form2.reason2 || !this.form2.content3){
                    this.$alert('违法事实或案由为空请先进行省数据同步！', '', {
                        confirmButtonText: '确定',
                        callback: action => {
                            // this.$message({
                            // type: 'info',
                            // message: ``
                            // });
                        }
                    }); 
                }
                console.log(this.form1.zzdm)
                if(!this.form1.zzdm){
                    console.log(this.form1.zzdm)
                    this.$alert('统一社会信用代码为空！请补全信息后再次点击基本信息比对！', '', {
                        confirmButtonText: '确定',
                        callback: action => {
                            // this.$message({
                            // type: 'info',
                            // message: ``
                            // });
                        }
                    }); 
                }
            }
            this.code = item.wsCode
            this.title = item.wsName
            this.open = true
        },
        handleBack(){
            this.open = false
            this.$forceUpdate()
        },
        getFalv(text,val){
            this.title3 = text
            this.open3 = true
            this.leixing = val
        },
        
        getAnyou(text,val){
            this.title4 = text
            this.open4 = true
            this.leixing2 = val
        },
        delectAnyou(index){
            console.log(index)
            this.form2.domains.splice(index,1)
        },
        getBacl(){
            this.open5 = true
            this.baly = ''
        },
        //并案理由提交
        balyTj(){
            if(this.baly){
                console.log(this.baly)
            }else{
                this.$message.error('请输入并案理由！')
            }
        },
        //自定义笔录
        getBlzdy(){
            this.open9 = true
        },
        //并案理由提交
        zdyblTj(){
            if(this.blnr){
                console.log(this.blnr)
            }else{
                this.$message.error('请输入笔录内容！')
            }
        },
        //复制笔录
        getFuzhi(text){
            console.log(text)
        },
        //法律弹窗返回内容
        handleBackFalv(data,val){
            console.log(data)
            if(val == 1){
                this.form2.law = data
            }else{
                this.form2.punish_basis = data
            }
            this.open3 = false
        },
        closeFalv(data){
            console.log(data)
            this.open3 = false
        },
        //增加从案由
        addAnyou(){
            this.isAy = this.form2.domains.length > 0 ? this.form2.domains[this.form2.domains.length - 1].key+1 : this.isAy + 1
            console.log(this.isAy)
            this.form2.domains.push({value:'',key:this.isAy})
            console.log(this.form2.domains)
        },
        //案由弹窗返回内容
        handleBackAnyou(data,val){
            console.log(data,val)
            if(val == 1){
                if(this.form2.reason22 && this.form2.reason22 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    this.form2.reason2 = data
                    this.open4 = false
                }
            }else{
                if(this.form2.reason2 && this.form2.reason2 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    this.form2.reason22 = data
                    this.open4 = false
                }
            }
        },
        closeAnyou(data){
            console.log(data)
            this.open4 = false
        },
        //询问笔录弹窗
        getXwtk(){
            this.textXw = this.form2.jiancha_rq
            this.open10 = true
        },
        handleBackXunwen(data){
            this.form2.content2 = data
            this.open10 = false
        },
        closeXunwen(data){
            this.open10 = false
        },
        //违法事实弹窗
        getWfss(){
            this.open11 = true
        },
        handleBackShishi(data){
            this.form2.content3 = data
            this.open11 = false
        },
        closeShishi(data){
            this.open11 = false
        },
        //本案取得的证据
        getBazj(){
            this.open12 = true
        },
        handleBackZhengju(data){
            this.form2.content4 = data
            this.open12 = false
        },
        closeZhengju(data){
            this.open12 = false
        },
        //处理建议
        getCljy(){
            this.open13 = true
        },
        handleBackJianyi(data){
            this.form2.content5 = data
            this.open13 = false
        },
        closeJianyi(data){
            this.open13 = false
        },
        //说理内容
        getSlnr(){
            this.open14 = true
        },
        handleBackShuoli(data){
            this.form2.content6 = data
            this.open14 = false
        },
        closeShuoli(data){
            this.open14 = false
        },
        //省数据同步
        async provinceData(){
            if(this.form1.zzdm){
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJgdxDataSync&dwmc=${escape(this.form1.dwmc)}&mid=${this.dwId}&type=0&code=0&creditCode=${this.form1.zzdm}&isClose=0`)
                console.log(data)
                if(data.data){
                    let valdata = data.data[0].valdata
                    if(data.data[0].outs == '0'){
                        this.$message.error('未查询到省系统有此单位！')
                        this.open8 = true
                    }else if(data.data[0].outs == '99'){
                        this.$message.error('程序异常！请重新点击一次！')
                    }
                    if(valdata != '0'){
                        let object = data.data[0].valdata[0].datas[0]
                        console.log(object)

                    }
                }else{
                    this.$message.error('程序异常！请重新点击一次！')
                }
            }else{
                this.$message.error('统一社会信用代码为空！请补全信息后再次点击基本信息比对！')
            }
        },
        getHysj(){
            console.log(this.form2.heyisj2)
            if(this.form2.heyisj2){
                this.form2.heyisj_begin = this.form2.heyisj2[0]
                this.form2.heyisj_end = this.form2.heyisj2[1]
            }
            console.log(this.form2.heyisj_begin,this.form2.heyisj_end)
        },
        //暂存
        async save(){
            let type = 1;
            let ajflag = 0;
            if(this.form2.jinggao && !this.form2.fakuan && !this.form2.moshou && !this.form2.moshou2){
                ajflag = 0;
            }else{
                ajflag = 1;
            }
            
            console.log(this.form2)
            axios({
                method: 'post',
                url: `${this.Global._baseUrl2}`,
                data: {
                    act: "saveZfxx",
                    type:  escape(type == 1 ? '暂存' : '保存'),
                    id: `${this.ajId}`,
                    c_mid:`${this.cmid}`,
                    xm: escape(this.xm),
                    dm: this.dm,
                    dw_flag:  `${this.dwFlag}`,
                    ajflag: ajflag,
                    spLsh:  `${this.form2.spLsh}`, 
                    bl_lsh:  `${this.form2.bl_lsh}`,  
                    dwmc_id: `${this.dwId}`, 
                    jiancha_rq: `${this.getDate(this.form2.jiancha_rq,'yyyy-MM-dd')}`,  
                    jc_rq:  `${this.getDate(this.form2.jc_rq,'yyyy-MM-dd')}`,  
                    laiyuan: `${escape(this.form2.laiyuan)}`,  
                    lian_rq: `${this.getDate(this.form2.lian_rq,'yyyy-MM-dd')}`,  
                    shouli_rq: `${this.getDate(this.form2.shouli_rq,'yyyy-MM-dd')}`,  
                    aj_shouli_rq: `${this.getDate(this.form2.aj_shouli_rq,'yyyy-MM-dd')}`,  
                    heyisj: `${this.getDate(this.form2.heyisj,'yyyy-MM-dd')}`,  
                    heyisj_begin: `${this.getDate(this.form2.heyisj_begin,'yyyy-MM-dd hh:mm:ss')}`,  
                    heyisj_end: `${this.getDate(this.form2.heyisj_end,'yyyy-MM-dd hh:mm:ss')}`,  
                    jinggao:  this.form2.jinggao ? true : false,  
                    fakuan:  (this.form2.fakuan > 0 || Number(this.form2.fakuanJine) > 0) ? true : false,  
                    fakuanJine: `${Number(this.form2.fakuanJine)}`,  
                    moshou: `${this.form2.moshou}`,  
                    moshouJine: `${Number(this.form2.moshouJine)}`,  
                    moshou2: this.form2.moshou2 ? true : false,  
                    txtWupin: Number(this.form2.txtWupin) > 0 ? Number(this.form2.txtWupin) : 0,  
                    law: `${escape(this.form2.law)}`, 
                    punish_basis: `${escape(this.form2.punish_basis)}`,
                    jingbanKs: `${escape(this.form2.jingbanks)}`,
                    host_man: `${escape(this.form2.host_man)}`,
                    hostdh: `${this.form2.hostdh}`,
                    factHost: `${this.form2.factHost}`,
                    cooperate_man: `${escape(this.form2.xiebanren)}`,
                    join_man: `${escape(this.form2.join_man)}`,
                    reason1: `${escape(this.form2.reason1)}`,
                    reason2: `${escape(this.form2.reason2)}`,
                    reason22: `${escape(this.form2.reason22)}`,
                    lianWenhao:  `${this.form2.lianWenhao}`,
                    gzsNo2: `${this.form2.gzsNo2}`,
                    gzsNo3:  `${this.form2.gzsNo3}`,
                    gzsNo4:  `${this.form2.gzsNo4}`,
                    jdsNo2:  `${this.form2.jdsNo2}`,
                    jdsNo3:  `${this.form2.jdsNo3}`,
                    jdsNo4:  `${this.form2.jdsNo4}`,
                    content11: `${escape(this.form2.content11)}`,
                    dashuju:  `${escape(this.form2.dashuju)}`,
                    content12:  `${escape(this.form2.content12)}`,
                    content2: `${escape(this.form2.content2)}`,
                    content3: `${escape(this.form2.content3)}`,
                    content4: `${escape(this.form2.content4)}`,
                    content5: `${escape(this.form2.content5)}`,
                    content6: `${escape(this.form2.content6)}`,
                    dwdz: `${escape(this.form2.dwdz)}`,
                    xkzh: `${escape(this.form2.xkzh)}`,
                    fzr: `${escape(this.form2.fzr)}`,
                    xb: `${escape(this.form2.xb)}`,
                    nation: `${this.form2.nation}`,
                    zw: `${escape(this.form2.zw)}`,
                    tyshxydm: `${this.form2.tyshxydm}`, 
                    sfzh: `${this.form2.sfzh}`,
                    sj1: `${this.form2.sj1}`,
                    dwdz2: `${escape(this.form2.dwdz2)}`,
                    xkzh2: `${escape(this.form2.xkzh2)}`,
                    fzr2: `${escape(this.form2.fzr2)}`,
                    xb2: `${escape(this.form2.xb2)}`,
                    nation2: `${escape(this.form2.nation2)}`,
                    zw2: `${escape(this.form2.zw2)}`,
                    tyshxydm2: `${escape(this.form2.tyshxydm2)}`,
                    sfzh2: `${escape(this.form2.sfzh2)}`,
                    sj12: `${escape(this.form2.sj12)}`,
                    ts_shijian:  `${this.form2.ts_shijian}`,
                    ts_nr:  `${this.form2.ts_nr}`,
                    jc_company: `${this.form2.jc_company}`,
                    jc_jcbh:  `${this.form2.jc_jcbh}`,
                    jc_jieshouDate:  `${this.form2.jc_jieshouDate}`,
                    jc_gaozhiDate: `${this.form2.jc_gaozhiDate}`,
                    content112:  `${escape(this.form2.content112)}`,
                    content113: `${escape(this.form2.content113)}`, 
                    sjssj: this.form2.sjssj == 'yes' ? 'yes' : 'no',
                    gjssj: this.form2.gjssj == 'yes' ? 'yes' : 'no',
                    isYbjc: this.form2.isybjc == 'yes' ? 'yes' : 'no',
                    isTsjb: this.form2.istsjb == 'yes' ? 'yes' : 'no',
                    dxxkz: `${this.form2.dxxkz}`,
                    zltcty: `${this.form2.zltcty}`,
                    xwbl_splsh: `${this.form2.xwbl_splsh}`,
                    zyclid: `${this.form2.zyclid}`,
                    buyuChufa: this.form2.buyuChufa ? 1 : 0,
                    ajly_hidden: this.form2.isnoxcbl ? 1 : 0,
                    strpunishCaseCode:  `${this.form2.strpunishCaseCode}`,
                },
                transformRequest: [function (data) {
                    data = qs.stringify(data);
                    return data;
                }],
                headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
            }).then(res => {
                if(res.data[0].errcode == '0'){
                    this.$message({
                        message: '暂存成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: res.data[0].errMessage,
                        type: 'error'
                    });
                }
                console.log(res)
            }).catch(res => {
                this.$message({
                    message: '保存失败，请重新填写',
                    type: 'error'
                });
            })
        },
        getText(){
            console.log(this.form1.fzr)
            console.log(this.dwForm.fzr)
        }
    }
}
</script>


<style scoped>
.box-cont >>> .search .el-input__inner{ border-radius: 20px;}
.box-cont >>> .el-input.is-disabled .el-input__inner { color: #333;}
.box-cont ul li{padding: 0px 10px 0 15px; margin-top: 10px; width: calc(100% - 27px);height: 54px; line-height: 54px;font-size: 16px;color: #333333; background: #FFFFFF;border-radius: 2px;border: 1px solid #DEDEDE;cursor: pointer;}
.box-cont ul li.active{ color: #0C80E8;}
.box-cont ul li span{ float: left;width: calc(100% - 20px);overflow: hidden; white-space: nowrap;text-overflow: ellipsis;}
.box-cont ul li i{color: #0C80E8; float: right; line-height: 58px; font-size: 18px;}
</style>
